module.exports = (__webpack_require__(7))(456);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@ng-bootstrap/ng-bootstrap/index.js from dll-reference vendor
// module id = 5
// module chunks = 0